/**
 * 접근 토큰이 만료됐을 때 한 번만 갱신하고 원래 요청을 다시 보내기 위한 판단.
 *
 * 예전에는 401 이 오면 곧바로 세션을 지우고 로그인 화면으로 보냈다.
 * 접근 토큰 수명이 15분이라, 15분만 지나면 로그인이 풀린 것처럼 보였다.
 */

export const REFRESH_PATH = '/auth/refresh-token'

/** 401 이 정상인 경로 — 자격 증명이 틀렸다는 뜻이라 갱신으로 가릴 수 없다 */
const CREDENTIAL_PATHS = [
  '/auth/login',
  '/auth/admin/login',
  '/auth/register',
  '/auth/guest-login',
]

export interface RefreshAttemptInput {
  status?: number
  url?: string
  alreadyRetried: boolean
}

export function shouldAttemptRefresh({
  status,
  url,
  alreadyRetried,
}: RefreshAttemptInput): boolean {
  if (status !== 401 || alreadyRetried || !url) {
    return false
  }
  if (url.includes(REFRESH_PATH)) {
    return false
  }
  return !CREDENTIAL_PATHS.some(path => url.includes(path))
}
